const Constant = {
  SET: 'SET_PREVIEW',
};

export default Constant;
